<template>
  <div class="affiliate-overview-grid">
    <article class="aff-stat-card aff-stat-card--earnings">
      <span class="aff-stat-card__label">Total earnings</span>
      <StatsLoaderComponent v-show="loading" />
      <template v-if="!loading">
        <div class="aff-stat-card__value">{{ money(stats.total_earning) }}</div>
        <div class="aff-stat-card__delta">+ {{ money(thisMonthEarning) }} this month</div>
        <p class="aff-stat-card__foot">{{ earningsFootnote }}</p>
      </template>
    </article>

    <article class="aff-stat-card aff-stat-card--balance">
      <div class="aff-stat-card__icon aff-stat-card__icon--balance" aria-hidden="true">
        <svg width="20" height="18" viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.8571 19.0477C22.8571 17.6332 23.419 16.2767 24.4192 15.2765C25.4194 14.2763 26.776 13.7144 28.1905 13.7144H32V10.6668C32 9.85847 31.6789 9.0833 31.1074 8.51176C30.5358 7.94022 29.7607 7.61913 28.9524 7.61913H3.04762C1.92099 7.62168 0.834049 7.20321 0 6.4458V27.4287C0 28.6411 0.481631 29.8038 1.33894 30.6611C2.19625 31.5185 3.35901 32.0001 4.57143 32.0001H28.9524C30.1648 32.0001 31.3276 31.5185 32.1849 30.6611C33.0422 29.8038 33.5238 28.6411 33.5238 27.4287V24.381H28.1905C26.776 24.381 25.4194 23.8191 24.4192 22.8189C23.419 21.8187 22.8571 20.4622 22.8571 19.0477Z" fill="currentColor"/>
          <path d="M33.5237 15.238H28.1904C27.18 15.238 26.2111 15.6394 25.4966 16.3538C24.7822 17.0682 24.3809 18.0372 24.3809 19.0476C24.3809 20.0579 24.7822 21.0269 25.4966 21.7413C26.2111 22.4557 27.18 22.8571 28.1904 22.8571H33.5237C33.9279 22.8571 34.3154 22.6965 34.6012 22.4108C34.887 22.125 35.0475 21.7374 35.0475 21.3333V16.7618C35.0475 16.3577 34.887 15.9701 34.6012 15.6844C34.3154 15.3986 33.9279 15.238 33.5237 15.238ZM28.9523 20.5714C28.6509 20.5714 28.3563 20.482 28.1057 20.3146C27.8551 20.1471 27.6598 19.9091 27.5445 19.6307C27.4291 19.3523 27.399 19.0459 27.4578 18.7503C27.5166 18.4547 27.6617 18.1832 27.8748 17.9701C28.0879 17.757 28.3594 17.6118 28.655 17.553C28.9506 17.4942 29.257 17.5244 29.5354 17.6397C29.8139 17.7551 30.0519 17.9504 30.2193 18.201C30.3867 18.4516 30.4761 18.7462 30.4761 19.0476C30.4761 19.4517 30.3156 19.8393 30.0298 20.1251C29.744 20.4108 29.3564 20.5714 28.9523 20.5714Z" fill="currentColor"/>
          <path d="M3.04762 6.09524H28.9524C30.1648 6.09524 31.3276 6.57687 32.1849 7.43418C33.0422 8.29149 33.5238 9.45425 33.5238 10.6667V4.57143C33.5238 3.35901 33.0422 2.19625 32.1849 1.33894C31.3276 0.481631 30.1648 0 28.9524 0H3.04762C2.23934 0 1.46417 0.321087 0.892627 0.892627C0.321088 1.46417 0 2.23934 0 3.04762C0 3.8559 0.321088 4.63107 0.892627 5.20261C1.46417 5.77415 2.23934 6.09524 3.04762 6.09524Z" fill="currentColor"/>
        </svg>
      </div>
      <div class="aff-stat-card__body">
        <StatsLoaderComponent v-show="loading" />
        <template v-if="!loading">
          <div class="aff-stat-card__value">{{ money(stats.unpaid_bonus) }}</div>
          <div class="aff-stat-card__name">Current balance</div>
        </template>
      </div>
    </article>

    <article class="aff-stat-card aff-stat-card--withdrawn">
      <div class="aff-stat-card__icon aff-stat-card__icon--withdrawn" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 19V5M12 5L6 11M12 5L18 11" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="aff-stat-card__body">
        <StatsLoaderComponent v-show="loading" />
        <template v-if="!loading">
          <div class="aff-stat-card__value">{{ money(stats.paid_bonus) }}</div>
          <div class="aff-stat-card__name">Total withdrawn</div>
        </template>
      </div>
    </article>

    <article class="aff-stat-card aff-stat-card--orders">
      <div class="aff-stat-card__icon aff-stat-card__icon--orders" aria-hidden="true">
        <svg width="20" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 14C4 14 5.5 12 8.5 12C11.5 12 12.5 16 15.5 16C18.5 16 20 14 20 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4 10C4 10 5.5 8 8.5 8C11.5 8 12.5 12 15.5 12C18.5 12 20 10 20 10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="aff-stat-card__body">
        <StatsLoaderComponent v-show="loading" />
        <template v-if="!loading">
          <div class="aff-stat-card__value">{{ orderCount }}</div>
          <div class="aff-stat-card__name">Orders</div>
        </template>
      </div>
    </article>

    <article class="aff-stat-card aff-stat-card--referrals">
      <div class="aff-stat-card__icon aff-stat-card__icon--referrals" aria-hidden="true">
        <svg width="20" height="16" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 18V16.4C16 15.12 16 14.48 15.782 13.968C15.5903 13.517 15.273 13.1295 14.868 12.852C14.407 12.536 13.807 12.4 12.607 12.4H7.393C6.193 12.4 5.593 12.4 5.132 12.716C4.727 12.9935 4.4097 13.381 4.218 13.832C4 14.344 4 14.984 4 16.264V18M20 18V16.7C20 15.574 20 15.011 19.818 14.564C19.658 14.171 19.4 13.831 19.068 13.576C18.688 13.286 18.181 13.17 17.167 13.12M15 4.13C15.512 4.427 15.903 4.868 16.114 5.388C16.325 5.908 16.345 6.48 16.17 7.013C15.995 7.547 15.636 8.014 15.147 8.345C14.657 8.676 14.063 8.853 13.455 8.85M12 8.4C13.6569 8.4 15 7.05685 15 5.4C15 3.74315 13.6569 2.4 12 2.4C10.3431 2.4 9 3.74315 9 5.4C9 7.05685 10.3431 8.4 12 8.4Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="aff-stat-card__body">
        <StatsLoaderComponent v-show="loading" />
        <template v-if="!loading">
          <div class="aff-stat-card__value">{{ referralCount }}</div>
          <div class="aff-stat-card__name">Total referrals (signed up)</div>
        </template>
      </div>
    </article>
  </div>
</template>

<script>
import StatsLoaderComponent from "@/components/StatsLoaderComponent.vue";
import { numberFormat } from "@/prod.js";
import { truncateMoney } from "@/utils/money.js";
import moment from "moment";

export default {
  components: {
    StatsLoaderComponent,
  },
  props: {
    affiliateStatsData: {
      default: () => ({}),
    },
    earningLists: {
      type: Array,
      default: () => [],
    },
    payouts: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      numberFormat,
      truncateMoney,
    };
  },
  methods: {
    money(value) {
      return this.numberFormat(this.truncateMoney(value), "currency");
    },
    parseDate(value) {
      if (!value) return null;
      const formats = [
        moment.ISO_8601,
        "YYYY-MM-DD HH:mm:ss",
        "YYYY-MM-DD",
        "MM/DD/YYYY",
        "DD/MM/YYYY",
        "MMM DD, YYYY",
        "D MMM YYYY",
        "MMMM D, YYYY",
      ];
      const parsed = moment(value, formats, true);
      if (parsed.isValid()) return parsed;
      const loose = moment(value);
      return loose.isValid() ? loose : null;
    },
    formatMonthYear(date) {
      return date ? date.format("MMM YYYY") : "";
    },
  },
  computed: {
    statsSource() {
      const raw = this.affiliateStatsData;
      if (!raw || Array.isArray(raw)) return {};
      if (
        raw.data &&
        typeof raw.data === "object" &&
        !Array.isArray(raw.data) &&
        (raw.data.total_earning !== undefined ||
          raw.data.paid_bonus !== undefined ||
          raw.data.unpaid_bonus !== undefined)
      ) {
        return raw.data;
      }
      return raw;
    },
    stats() {
      const src = this.statsSource;
      return {
        paid_bonus: Number(src.paid_bonus || 0),
        total_earning: Number(src.total_earning || 0),
        total_users_signup: Number(src.total_users_signup || 0),
        unpaid_bonus: Number(src.unpaid_bonus || 0),
      };
    },
    thisMonthEarning() {
      const apiValue = this.statsSource.this_month_earning;
      if (apiValue !== undefined && apiValue !== null && apiValue !== "") {
        return Number(apiValue) || 0;
      }
      const now = moment();
      return this.earningLists.reduce((sum, item) => {
        const date = this.parseDate(item.created_at);
        if (date && date.isSame(now, "month") && date.isSame(now, "year")) {
          return sum + Number(item.earned_bonus || 0);
        }
        return sum;
      }, 0);
    },
    totalOrders() {
      if (this.statsSource.total_orders !== undefined) {
        return Number(this.statsSource.total_orders) || 0;
      }
      return this.earningLists.length;
    },
    sinceDate() {
      const apiSince = this.statsSource.since || this.statsSource.start_date;
      const apiDate = this.parseDate(apiSince);
      if (apiDate) return apiDate;
      const dates = this.earningLists
        .map((item) => this.parseDate(item.created_at))
        .filter(Boolean)
        .sort((a, b) => a.valueOf() - b.valueOf());
      return dates[0] || null;
    },
    earningsFootnote() {
      const referrals = this.stats.total_users_signup;
      const orders = this.totalOrders;
      const since = this.formatMonthYear(this.sinceDate);
      const base = `From ${orders} ${orders === 1 ? "order" : "orders"} across ${referrals} ${
        referrals === 1 ? "referral" : "referrals"
      }`;
      return since ? `${base} · since ${since}` : base;
    },
    referralCount() {
      return Math.floor(this.stats.total_users_signup).toLocaleString();
    },
    orderCount() {
      return Math.floor(this.totalOrders).toLocaleString();
    },
  },
};
</script>
